export default __webpack_public_path__ + "static/medication-m-d763204821d99d4a6e427966e2d956c6.svg";